/**
 * Enum with all different mixpanel origins to use
 */
export const ORIGINS = {
  sourcing: 'sourcing',
  invite_tracker: 'sourcing_invitations_tracker',
  predictive_models: 'pms_table',
  'view-campaign': 'campaign_view',
  network: 'network',
  profile: 'profile'
};
